import { render } from "./CustomerPage.vue?vue&type=template&id=13819c3a"
import script from "./CustomerPage.vue?vue&type=script&lang=js"
export * from "./CustomerPage.vue?vue&type=script&lang=js"

import "./CustomerPage.vue?vue&type=style&index=0&id=13819c3a&lang=css"

import exportComponent from "/Users/1M/Projects/SLE/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__